import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { useOnExpand } from "../../../../hooks/hooks/use-on-expand.js";
import { onKeyDown } from "../../../../utils/utils/expand-on-keydown.js";
import OpeningHoursSpecial from "./OpeningHoursSpecial.js";
const OpeningSpecialHoursContainer = ({ labels, special }) => {
  const isSpecialHoursExpandable = special.length > 2;
  const { isExpanded, onExpand } = useOnExpand({ initialIsExpanded: false });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isSpecialHoursExpandable && /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-t": "SpecialHoursExpand",
      onClick: onExpand,
      onKeyDown: (e) => onKeyDown(e, onExpand),
      className: classnames("location-opening-hours__special", {
        "location-opening-hours--expandable": isSpecialHoursExpandable
      })
    },
    /* @__PURE__ */ React.createElement("span", { className: "location-opening-hours__list-heading--special" }, labels.specialTitle),
    /* @__PURE__ */ React.createElement(
      Icon,
      {
        width: 16,
        height: 16,
        className: "location-opening-hours__icon",
        name: isExpanded ? "chevron-up" : "chevron-down"
      }
    )
  ), /* @__PURE__ */ React.createElement(
    OpeningHoursSpecial,
    {
      special,
      amountToDisplay: isExpanded ? special.length : Math.min(special.length, 2)
    }
  ));
};
export {
  OpeningSpecialHoursContainer as default
};
//# sourceMappingURL=OpeningHoursSpecialContainer.js.map
